// Full-document render of the loadup (mattress pickup request) confirmation
// page: PageSkeleton wrapping LoadupRequestConfirmationPageBody.
import React from "react";

import { templates } from "@reactivated";

import { LoadupRequestConfirmationPageBody } from "../components/LoadupRequestConfirmationPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LoadupRequestConfirmationDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <LoadupRequestConfirmationPageBody />
    </PageSkeleton>
);
